// extracted by mini-css-extract-plugin
module.exports = {"pt-trust-order-detail":"pt-trust-order-detail-5a7d56e2e1f4e1d5b1a038dfedec07c7","fixedBox":"fixedBox-ae802fd80c36367c1c9886b3e5b5d2ab"};